import React, { useState } from "react";
import { Offcanvas, Button } from "react-bootstrap";

// PDF Viewer
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// Styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import GlassMagnifier from "./GlassMagnifier";

interface PdfViewerDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  fileUrl: string | null;
}

const PdfViewerDrawer: React.FC<PdfViewerDrawerProps> = ({
  isOpen,
  onClose,
  fileUrl,
}) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const isPdf = fileUrl?.toLowerCase().endsWith(".pdf");
  const isImage = /\.(png|jpe?g|gif|tiff?|heif|heic|webp)$/i.test(
    fileUrl || ""
  );

  // 🔍 Image Zoom State
  const [zoom, setZoom] = useState(1);

  // 🔄 Reset zoom when viewer closes
  React.useEffect(() => {
    if (!isOpen) setZoom(1);
  }, [isOpen]);

  // 🖨️ Print image

  return (
    <Offcanvas
      show={isOpen}
      onHide={onClose}
      placement="end"
      backdrop
      scroll
      style={{ width: "80vw", overflow: "hidden" }}
      className="view-pdf"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {isPdf ? "View PDF" : isImage ? "View Image" : "File Viewer"}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body style={{ height: "100%", overflow: "auto" }}>
        {fileUrl && isPdf && (
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <div style={{ height: "80vh" }}>
              <Viewer
                fileUrl={fileUrl}
                plugins={[defaultLayoutPluginInstance]}
              />
            </div>
          </Worker>
        )}

        {fileUrl && isImage && (
          <>
            <div id="image-viewer" className="d-flex justify-content-center">
              <div className="d-flex justify-content-center">
                <GlassMagnifier src={fileUrl} />
              </div>
            </div>
          </>
        )}

        {fileUrl && !isPdf && !isImage && (
          <div className="text-center text-danger mt-3">
            Unsupported file format.
          </div>
        )}
        {fileUrl && (
          <div
            style={{
              position: "absolute",
              bottom: 20,
              right: 30,
              zIndex: 10,
            }}
          >
            <Button
              variant="primary"
              size="sm"
              onClick={() => {
                const link = document.createElement("a");
                link.href = fileUrl;
                link.download = fileUrl.split("/").pop() || "file.pdf";
                link.click();
              }}
            >
              Download
            </Button>
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default PdfViewerDrawer;
